import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CloseModalComponent } from "../close-modal/close-modal.component";
import { UnsavedChangesModalService } from "./service/unsaved-changes-modal.service";

@Component({
  selector: 'app-unsaved-changes-modal-wrapper',
  templateUrl: './unsaved-changes-modal-wrapper.component.html',
  imports: [
    CloseModalComponent,
  ],
  styleUrls: ['./unsaved-changes-modal-wrapper.component.scss'],
  standalone: true,
})

export class UnsavedChangesModalWrapperComponent implements OnInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  private unsavedChangesModalService = inject(UnsavedChangesModalService);

  showModal: boolean = false;

  ngOnInit(): void {
      this.unsavedChangesModalService.showModalEmitter
      .pipe(takeUntil(this._destroyStream))
      .subscribe((value) => {
        this.showModal = value; // This will show the modal
      });

      // Existing subscription to handle the resolution of the dialog
      this.unsavedChangesModalService.showConfirmDialog()
      .pipe(takeUntil(this._destroyStream))
      .subscribe((value) => this.showModal = value);

  }

  closeModal(confirmation: boolean): void {
    this.unsavedChangesModalService.resolveDialog(confirmation);
    this.showModal = false;
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }
}
